import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54dc44d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PretensionForm" }
const _hoisted_2 = { class: "PretensionFormHeader" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  key: 1,
  class: "ml-6 fas fa-check-circle text-green-500"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-refresh mr-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-refresh mr-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-refresh mr-2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "PretensionsLoader"
}
const _hoisted_13 = {
  key: 1,
  class: "Pretensions"
}
const _hoisted_14 = { class: "PretensionInputs" }
const _hoisted_15 = {
  key: 1,
  class: "mt-3 w-full flex justify-between"
}
const _hoisted_16 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_17 = {
  key: 0,
  class: "p-10 PretensionFormFiles"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1))
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))
const _hoisted_21 = {
  key: 5,
  class: "p-10 PretensionFormFiles"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1))
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))
const _hoisted_25 = { class: "PretensionInputs" }
const _hoisted_26 = {
  key: 3,
  class: "PretensionFormFooter flex items-center justify-between mt-6"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_28 = {
  key: 4,
  class: "PretensionFormFooter flex items-center justify-between mt-6"
}
const _hoisted_29 = {
  key: 0,
  class: "flex-col w-full"
}
const _hoisted_30 = { class: "p-10 PretensionFormFiles" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1))
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))
const _hoisted_34 = { class: "PretensionFormSigns" }
const _hoisted_35 = { class: "w-1/2 border-b-2 flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_file_reader = _resolveComponent("file-reader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_page_title, { title: _ctx.getTitle }, null, 8, ["title"]),
        (_ctx.state.pretension.data)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 0,
              class: "small ml-6"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.pretension.data.status_name) + " " + _toDisplayString(_ctx.state.pretension.data.status_changed_at), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isOnClosedStatus && _ctx.state.final_file.length > 0)
          ? (_openBlock(), _createElementBlock("i", _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_button_dropdown, {
        title: "Выберите действие",
        placement: "bottom",
        "allowed-placements": ['bottom']
      }, {
        default: _withCtx(() => [
          (_ctx.isUpdate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.isUpdatableStatus && (_ctx.isCreator || _ctx.state.is_quality_control))
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 0,
                      class: "primary text small",
                      loading: _ctx.state.is_loading,
                      onClick: _ctx.updatePretensionInfo
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Сохранить данные ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.onReturnToInProgress || _ctx.state.is_quality_control)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 1,
                      class: "primary text small",
                      loading: _ctx.state.is_loading,
                      onClick: _ctx.returnToInProgress
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        _createTextVNode(" Вернуть в работу ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCreatedStatus && _ctx.state.is_quality_control)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 2,
                      class: "primary text small",
                      loading: _ctx.state.is_loading,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeStatus('in progress')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Принять в работу ")
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (_ctx.isInProgressStatusQQ && _ctx.state.is_quality_control)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 3,
                      class: "primary text small",
                      loading: _ctx.state.is_loading,
                      onClick: _ctx.addQualityControlComment
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Отправить в СБ ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isInProgressStatusSB && _ctx.state.is_sb)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 4,
                      class: "primary text small",
                      loading: _ctx.state.is_loading,
                      onClick: _ctx.addSBComment
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Отправить в КК ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                (!_ctx.isLegalDepartment)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 5,
                      class: "primary text small",
                      loading: _ctx.state.is_loading,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeStatus('in_progress_ld')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _createTextVNode(" Отправить в ЮО ")
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (_ctx.isLegalDepartment)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 6,
                      class: "primary text small",
                      loading: _ctx.state.is_loading,
                      onClick: _ctx.saveLegalDepartmentComment
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createTextVNode(" Сохранить комментарий ЮО ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isInProgressStatusQQ && _ctx.state.is_quality_control)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 7,
                      class: "primary text small",
                      loading: _ctx.state.is_loading,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeStatus('оn approval')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Отправить на согласование ")
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (
                            (_ctx.isOnApprovalStatus && !(_ctx.state.final_file.length > 0)) ||
                            _ctx.state.is_quality_control
                        )
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 8,
                      class: "primary text small",
                      loading: _ctx.state.is_loading,
                      onClick: _ctx.sendFinalFile
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Отправить заключительный файл ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                (
                            (_ctx.isOnApprovalStatus && _ctx.isDeclined) ||
                            _ctx.isOnApprovedStatus ||
                            _ctx.state.is_quality_control
                        )
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 9,
                      class: "primary text small",
                      loading: _ctx.state.is_loading,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeStatus('closed')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Закрыть претензию ")
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (
                            ((_ctx.isOnClosedStatus || _ctx.isOnAgreedStatus) &&
                                _ctx.state.pretension.data.signed_file.data.length > 0) ||
                            _ctx.state.is_quality_control
                        )
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 10,
                      class: "primary text small",
                      loading: _ctx.state.is_loading,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadPretension(_ctx.state.pretension.data.signed_file.data[0].url)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9,
                        _createTextVNode("Скачать подписанную претензию ")
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (
                            (_ctx.isUpdate && _ctx.isCreator && _ctx.isCreatedStatus) || _ctx.state.is_quality_control
                        )
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 11,
                      class: "red text small",
                      loading: _ctx.state.is_loading,
                      onClick: _ctx.onDeletePretension
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createTextVNode("Удалить претензию ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_the_button, {
            class: "second text small",
            disabled: _ctx.state.is_loading,
            onClick: _ctx.emitCancel
          }, {
            default: _withCtx(() => [
              _hoisted_11,
              _createTextVNode(" Отмена ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    (_ctx.state.is_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_loader, { class: "primary" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_page_title, {
            class: "PretensionFormTitle",
            title: "Претензия"
          }),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_the_select, {
              class: "mt-2",
              placeholder: "Тип претензии",
              loading: _ctx.data_state.types.is_loading,
              failed: _ctx.data_state.types.is_failed,
              "error-text": "При получении списка типов произошла ошибка",
              "is-invalid": _ctx.state_form$.type_id.$error,
              "validation-errors": _ctx.state_form$.type_id.$errors,
              options: _ctx.data_state.types.list,
              value: _ctx.state.type_id,
              "onUpdate:value": [
                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.type_id) = $event)),
                _ctx.onTypeChange
              ],
              "infinite-scroll": "",
              onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadTypes(_ctx.data_state.types.pagination.current_page))),
              onLoadmore: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadMoreTypes(_ctx.data_state.types.pagination.current_page + 1))),
              disabled: _ctx.isUpdate && !_ctx.isUpdatableStatus
            }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value", "disabled", "onUpdate:value"]),
            (!_ctx.isOtherType)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 0,
                  placeholder: "Номер объекта",
                  value: _ctx.state.invoice_number,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.invoice_number) = $event)),
                  onInput: _ctx.onInvoiceNumberChange,
                  disabled: _ctx.isUpdate
                }, null, 8, ["value", "onInput", "disabled"]))
              : _createCommentVNode("", true),
            (_ctx.isUpdate)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 1,
                  placeholder: "Объект",
                  value: _ctx.state.object,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.object) = $event))
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (_ctx.isTypeSix)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 2,
                  placeholder: "Что получил клиент",
                  "is-invalid": _ctx.state_form$.what_received.$error,
                  "validation-errors": _ctx.state_form$.what_received.$errors,
                  value: _ctx.state.what_received,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.what_received) = $event))
                }, null, 8, ["is-invalid", "validation-errors", "value"]))
              : (_openBlock(), _createBlock(_component_the_input, {
                  key: 3,
                  placeholder: "Номер накладной заказчика",
                  value: _ctx.state.dop_invoice_number,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.dop_invoice_number) = $event))
                }, null, 8, ["value"])),
            _createVNode(_component_the_select, {
              class: "mt-2",
              placeholder: "Подразделение",
              loading: _ctx.data_state.subdivisions.is_loading,
              failed: _ctx.data_state.subdivisions.is_failed,
              "error-text": "При получении списка подразделений произошла ошибка",
              options: _ctx.data_state.subdivisions.list,
              value: _ctx.state.subdivision_id,
              "onUpdate:value": [
                _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.subdivision_id) = $event)),
                _ctx.onSubdivisionChange
              ],
              "is-invalid": _ctx.state_form$.subdivision_id.$error,
              "validation-errors": _ctx.state_form$.subdivision_id.$errors,
              onRefresh: _ctx.loadSubdivisions
            }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onRefresh", "onUpdate:value"]),
            _createVNode(_component_the_select, {
              class: "mt-2",
              placeholder: "Виновная сторона",
              loading: _ctx.data_state.guilty_sides.is_loading,
              failed: _ctx.data_state.guilty_sides.is_failed,
              "error-text": "При получении списка виновных сторон произошла ошибка",
              options: _ctx.data_state.guilty_sides.list,
              value: _ctx.state.guilty_side_id,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.guilty_side_id) = $event)),
              "is-invalid": _ctx.state_form$.guilty_side_id.$error,
              "validation-errors": _ctx.state_form$.guilty_side_id.$errors,
              onRefresh: _ctx.loadGuiltySides
            }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onRefresh"]),
            (!_ctx.isOtherType)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 4,
                  placeholder: "Направление",
                  value: _ctx.state.info.direction,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.info.direction) = $event)),
                  disabled: _ctx.state.is_info_ready
                }, null, 8, ["value", "disabled"]))
              : _createCommentVNode("", true),
            (!_ctx.isOtherType)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 5,
                  placeholder: "Дата доставки",
                  value: _ctx.state.info.delivery_date,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.info.delivery_date) = $event)),
                  disabled: _ctx.state.is_info_ready,
                  type: "date"
                }, null, 8, ["value", "disabled"]))
              : _createCommentVNode("", true),
            (!_ctx.isOtherType)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 6,
                  placeholder: "Название отправителя",
                  value: _ctx.state.sender_name,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.sender_name) = $event)),
                  disabled: _ctx.state.is_info_ready
                }, null, 8, ["value", "disabled"]))
              : _createCommentVNode("", true),
            (!_ctx.isOtherType)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 7,
                  placeholder: "Название получателя",
                  value: _ctx.state.receiver_name,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.receiver_name) = $event)),
                  disabled: _ctx.state.is_info_ready
                }, null, 8, ["value", "disabled"]))
              : _createCommentVNode("", true),
            (!_ctx.isOtherType)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 8,
                  placeholder: "Кто плательщик",
                  value: _ctx.state.info.payment_type,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.info.payment_type) = $event)),
                  disabled: _ctx.state.is_info_ready
                }, null, 8, ["value", "disabled"]))
              : _createCommentVNode("", true),
            (!_ctx.isOtherType)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 9,
                  placeholder: "Способ оплаты",
                  value: _ctx.state.info.payment_method,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.info.payment_method) = $event)),
                  disabled: _ctx.state.is_info_ready
                }, null, 8, ["value", "disabled"]))
              : _createCommentVNode("", true),
            _createVNode(_component_the_input, {
              placeholder: "ФИО клиента",
              value: _ctx.state.client_name,
              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.client_name) = $event)),
              "is-invalid": _ctx.state_form$.client_name.$error,
              "validation-errors": _ctx.state_form$.client_name.$errors,
              disabled: _ctx.isUpdate && !_ctx.isUpdatableStatus
            }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
            _createVNode(_component_the_input, {
              placeholder: "Телефон клиента",
              "is-invalid": _ctx.state_form$.client_phone.$error,
              "validation-errors": _ctx.state_form$.client_phone.$errors,
              value: _ctx.state.client_phone,
              "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.client_phone) = $event)),
              disabled: _ctx.isUpdate && !_ctx.isUpdatableStatus,
              maska: _ctx.PHONE_NUMBER_MASK
            }, null, 8, ["is-invalid", "validation-errors", "value", "disabled", "maska"]),
            _createVNode(_component_the_input, {
              placeholder: "Описание товара",
              "is-invalid": _ctx.state_form$.product_description.$error,
              "validation-errors": _ctx.state_form$.product_description.$errors,
              value: _ctx.state.product_description,
              "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.product_description) = $event)),
              disabled: _ctx.isUpdate && !_ctx.isUpdatableStatus
            }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"]),
            _createVNode(_component_the_select, {
              class: "mt-2",
              placeholder: "Компания",
              "is-invalid": _ctx.state_form$.company_id.$error,
              "validation-errors": _ctx.state_form$.company_id.$errors,
              loading: _ctx.data_state.companies.is_loading,
              failed: _ctx.data_state.companies.is_failed,
              "error-text": "При получении списка компаний произошла ошибка",
              options: _ctx.data_state.companies.list,
              value: _ctx.state.company_id,
              "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.company_id) = $event)),
              disabled: (_ctx.isUpdate && !_ctx.isUpdatableStatus) || _ctx.state.is_info_ready,
              "search-without-refresh": "",
              onRefresh: _cache[24] || (_cache[24] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page)))
            }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "disabled"]),
            _createVNode(_component_the_input, {
              placeholder: "Сумма претензии",
              "is-invalid": _ctx.state_form$.product_amount.$error,
              "validation-errors": _ctx.state_form$.product_amount.$errors,
              value: _ctx.state.product_amount,
              "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.product_amount) = $event)),
              disabled: _ctx.isUpdate && !_ctx.isUpdatableStatus
            }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"]),
            _createVNode(_component_the_input, {
              placeholder: "Email клиента",
              "is-invalid": _ctx.state_form$.client_email.$error,
              "validation-errors": _ctx.state_form$.client_email.$errors,
              value: _ctx.state.client_email,
              "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.client_email) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            (_ctx.isSpark)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 10,
                  placeholder: "Количество товаров",
                  "is-invalid": _ctx.state_form$.product_quantity.$error,
                  "validation-errors": _ctx.state_form$.product_quantity.$errors,
                  value: _ctx.state.product_quantity,
                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.product_quantity) = $event))
                }, null, 8, ["is-invalid", "validation-errors", "value"]))
              : _createCommentVNode("", true),
            (_ctx.isSpark)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 11,
                  placeholder: "Артикул",
                  "is-invalid": _ctx.state_form$.article_number.$error,
                  "validation-errors": _ctx.state_form$.article_number.$errors,
                  value: _ctx.state.article_number,
                  "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.article_number) = $event))
                }, null, 8, ["is-invalid", "validation-errors", "value"]))
              : _createCommentVNode("", true),
            (_ctx.isSpark)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 12,
                  placeholder: "Наименование товара",
                  "is-invalid": _ctx.state_form$.product_name.$error,
                  "validation-errors": _ctx.state_form$.product_name.$errors,
                  value: _ctx.state.product_name,
                  "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.product_name) = $event))
                }, null, 8, ["is-invalid", "validation-errors", "value"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_the_textarea, {
            class: "mt-3",
            placeholder: "Суть запроса",
            "is-invalid": _ctx.state_form$.client_comment.$error,
            "validation-errors": _ctx.state_form$.client_comment.$errors,
            value: _ctx.state.client_comment,
            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.client_comment) = $event)),
            disabled: _ctx.isUpdate && !_ctx.isUpdatableStatus,
            rows: 5,
            autoheight: ""
          }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"]),
          (_ctx.isCreate)
            ? (_openBlock(), _createBlock(_component_file_reader, {
                key: 0,
                class: "mt-3",
                placeholder: "Выберите файл",
                accept: "image/*, application/pdf",
                value: _ctx.state.files,
                "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.files) = $event)),
                "is-invalid": _ctx.state_form$.files.$error,
                "validation-errors": _ctx.state_form$.files.$errors,
                multiple: ""
              }, null, 8, ["value", "is-invalid", "validation-errors"]))
            : _createCommentVNode("", true),
          (_ctx.isUpdate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_file_reader, {
                  placeholder: "Выберите файл",
                  accept: "image/*, application/pdf",
                  value: _ctx.state.files_employee_add,
                  "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.files_employee_add) = $event)),
                  multiple: ""
                }, null, 8, ["value"]),
                _createVNode(_component_the_button, {
                  class: "primary text small",
                  loading: _ctx.state.is_loading,
                  onClick: _ctx.addFiles
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Добавить файлы ")
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isUpdate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (Boolean(_ctx.state.file_urls.length))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.file_urls, (el, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "flex items-center justify-between w-full mb-3",
                          key: `img-${idx}`
                        }, [
                          (_ctx.isPDF(el.url))
                            ? (_openBlock(), _createBlock(_component_the_button, {
                                key: 0,
                                class: "primary text small",
                                loading: _ctx.state.is_loading,
                                onClick: ($event: any) => (_ctx.downloadPretension(el.url))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_18,
                                  _createTextVNode("Скачать PDF-" + _toDisplayString(idx), 1)
                                ]),
                                _: 2
                              }, 1032, ["loading", "onClick"]))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: el.url,
                                alt: "image",
                                class: "max-w-md"
                              }, null, 8, _hoisted_19)),
                          _createVNode(_component_the_button, {
                            class: "primary red text small h-fit",
                            loading: _ctx.state.is_loading,
                            onClick: ($event: any) => (_ctx.deleteFile(el.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20,
                              _createTextVNode(" Удалить файл ")
                            ]),
                            _: 2
                          }, 1032, ["loading", "onClick"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isUpdate)
                  ? (_openBlock(), _createBlock(_component_the_textarea, {
                      key: 1,
                      class: "mt-3 PretensionFormTextarea",
                      placeholder: "Комментарий КК",
                      "is-invalid": 
                        _ctx.state_form$.quality_control_comment.$error ||
                        _ctx.state_approve_form$.quality_control_comment.$error
                    ,
                      "validation-errors": 
                        _ctx.state_form$.quality_control_comment.$errors ||
                        _ctx.state_approve_form$.quality_control_comment.$errors
                    ,
                      value: _ctx.state.quality_control_comment,
                      "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.quality_control_comment) = $event)),
                      disabled: !_ctx.isInProgressStatusQQ || !_ctx.state.is_quality_control,
                      rows: 5,
                      autoheight: ""
                    }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isUpdate)
                  ? (_openBlock(), _createBlock(_component_the_textarea, {
                      key: 2,
                      class: "mt-3 PretensionFormTextarea",
                      placeholder: "Комментарий СБ",
                      "is-invalid": _ctx.state_form$.security_service_comment.$error,
                      "validation-errors": _ctx.state_form$.security_service_comment.$errors,
                      value: _ctx.state.security_service_comment,
                      "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.security_service_comment) = $event)),
                      disabled: !_ctx.isInProgressStatusSB || !_ctx.state.is_sb,
                      rows: 5,
                      autoheight: ""
                    }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_the_textarea, {
                  class: "mt-3 LegalDepartmentComment",
                  placeholder: "Комментарий ЮО",
                  value: _ctx.state.legal_department_comment,
                  "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.legal_department_comment) = $event)),
                  disabled: !_ctx.isLegalDepartment,
                  rows: 5,
                  autoheight: ""
                }, null, 8, ["value", "disabled"]),
                (_ctx.isLegalDepartment)
                  ? (_openBlock(), _createBlock(_component_file_reader, {
                      key: 3,
                      class: "mt-3 LegalDepartmentFiles",
                      placeholder: "Файлы для ЮО",
                      accept: "image/*, application/pdf",
                      value: _ctx.state.files_legal_department,
                      "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.files_legal_department) = $event)),
                      "is-invalid": _ctx.legal_department_form$.files_legal_department.$error,
                      "validation-errors": _ctx.legal_department_form$.files_legal_department.$errors,
                      multiple: ""
                    }, null, 8, ["value", "is-invalid", "validation-errors"]))
                  : _createCommentVNode("", true),
                (_ctx.isUpdate && _ctx.isInProgressStatusQQ)
                  ? (_openBlock(), _createBlock(_component_file_reader, {
                      key: 4,
                      class: "mt-3",
                      placeholder: "Файлы для контроль качества",
                      accept: "image/*, application/pdf",
                      value: _ctx.state.files_employee_qc,
                      "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.files_employee_qc) = $event)),
                      multiple: ""
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (Boolean(_ctx.state.quality_control_file.length))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.quality_control_file, (el, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "flex items-center justify-between w-full mb-3",
                          key: `img-${idx}`
                        }, [
                          (_ctx.isPDF(el.url))
                            ? (_openBlock(), _createBlock(_component_the_button, {
                                key: 0,
                                class: "primary text small",
                                loading: _ctx.state.is_loading,
                                onClick: ($event: any) => (_ctx.downloadPretension(el.url))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_22,
                                  _createTextVNode("Скачать PDF-" + _toDisplayString(idx), 1)
                                ]),
                                _: 2
                              }, 1032, ["loading", "onClick"]))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: el.url,
                                alt: "image",
                                class: "max-w-md"
                              }, null, 8, _hoisted_23)),
                          _createVNode(_component_the_button, {
                            class: "primary red text small h-fit",
                            loading: _ctx.state.is_loading,
                            onClick: ($event: any) => (_ctx.deleteFile(el.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24,
                              _createTextVNode("Удалить файл ")
                            ]),
                            _: 2
                          }, 1032, ["loading", "onClick"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_the_select, {
                    class: "mt-2",
                    placeholder: "Компенсация",
                    loading: _ctx.data_state.compensations.is_loading,
                    failed: _ctx.data_state.compensations.is_failed,
                    "error-text": "При получении списка типов произошла ошибка",
                    options: _ctx.data_state.compensations.list,
                    value: _ctx.state.compensation_id,
                    "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.compensation_id) = $event)),
                    "infinite-scroll": "",
                    disabled: !_ctx.isInProgressStatusQQ,
                    "is-invalid": _ctx.state_form$.compensation_id.$error,
                    "validation-errors": _ctx.state_form$.compensation_id.$errors
                  }, null, 8, ["loading", "failed", "options", "value", "disabled", "is-invalid", "validation-errors"]),
                  _createVNode(_component_the_input, {
                    placeholder: "Сумма к возмещению",
                    value: _ctx.state.reimbursed_amount,
                    "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.reimbursed_amount) = $event)),
                    disabled: !_ctx.isInProgressStatusQQ,
                    "is-invalid": _ctx.state_form$.reimbursed_amount.$error,
                    "validation-errors": _ctx.state_form$.reimbursed_amount.$errors
                  }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
                  _createVNode(_component_the_select, {
                    class: "mt-2",
                    placeholder: "Виновная сторона",
                    loading: _ctx.data_state.culprits.is_loading,
                    failed: _ctx.data_state.culprits.is_failed,
                    "error-text": "При получении списка типов произошла ошибка",
                    options: _ctx.data_state.culprits.list,
                    value: _ctx.state.culprit_id,
                    "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.state.culprit_id) = $event)),
                    "infinite-scroll": "",
                    disabled: !_ctx.isInProgressStatusQQ,
                    "is-invalid": _ctx.state_form$.culprit_id.$error,
                    "validation-errors": _ctx.state_form$.culprit_id.$errors
                  }, null, 8, ["loading", "failed", "options", "value", "disabled", "is-invalid", "validation-errors"]),
                  _createVNode(_component_the_input, {
                    placeholder: "ФИО виновной стороны",
                    value: _ctx.state.culprit_name,
                    "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.culprit_name) = $event)),
                    disabled: !_ctx.isInProgressStatusQQ,
                    "is-invalid": _ctx.state_form$.culprit_name.$error,
                    "validation-errors": _ctx.state_form$.culprit_name.$errors
                  }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
                  _createVNode(_component_the_input, {
                    type: "date",
                    class: "w-full",
                    placeholder: "Дата согласования",
                    value: _ctx.state.agreement_date,
                    "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.state.agreement_date) = $event)),
                    disabled: !_ctx.isInProgressStatusQQ,
                    "is-invalid": _ctx.state_form$.agreement_date.$error,
                    "validation-errors": _ctx.state_form$.agreement_date.$errors
                  }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
                ]),
                (_ctx.isUpdate)
                  ? (_openBlock(), _createBlock(_component_the_textarea, {
                      key: 6,
                      class: "mt-3 PretensionFormTextarea",
                      placeholder: "Согласование",
                      "is-invalid": _ctx.state_form$.agreement_comment.$error,
                      "validation-errors": _ctx.state_form$.agreement_comment.$errors,
                      value: _ctx.state.agreement_comment,
                      "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.state.agreement_comment) = $event)),
                      disabled: !_ctx.isInProgressStatusQQ,
                      rows: 5,
                      autoheight: ""
                    }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isFinalFile)
                  ? (_openBlock(), _createBlock(_component_file_reader, {
                      key: 7,
                      class: "mt-3",
                      "is-invalid": _ctx.isFinalFile,
                      placeholder: "Загрузить заключительный файл",
                      accept: "image/*, application/pdf",
                      value: _ctx.state.files_employee_final,
                      "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.state.files_employee_final) = $event)),
                      multiple: ""
                    }, null, 8, ["is-invalid", "value"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isCreate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                (_ctx.isCreate)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 0,
                      class: "second text small",
                      disabled: _ctx.state.is_loading,
                      onClick: _ctx.resetForm
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27,
                        _createTextVNode(" Сбросить ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCreate)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 1,
                      class: "primary text small",
                      loading: _ctx.state.is_loading,
                      onClick: _ctx.addPretension
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Добавить ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (_ctx.state.final_file.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(_component_page_title, { title: "Заключительные файлы:" }),
                      _createElementVNode("div", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.final_file, (el, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "flex items-center justify-between w-full mb-3",
                            key: `img-${idx}`
                          }, [
                            (_ctx.isPDF(el.url))
                              ? (_openBlock(), _createBlock(_component_the_button, {
                                  key: 0,
                                  class: "primary text small",
                                  loading: _ctx.state.is_loading,
                                  onClick: ($event: any) => (_ctx.downloadPretension(el.url))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_31,
                                    _createTextVNode("Скачать Заключительный файл ")
                                  ]),
                                  _: 2
                                }, 1032, ["loading", "onClick"]))
                              : (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: el.url,
                                  alt: "image",
                                  class: "max-w-md"
                                }, null, 8, _hoisted_32)),
                            _createVNode(_component_the_button, {
                              class: "primary red text small h-fit",
                              loading: _ctx.state.is_loading,
                              onClick: ($event: any) => (_ctx.deleteFile(el.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_33,
                                _createTextVNode("Удалить файл ")
                              ]),
                              _: 2
                            }, 1032, ["loading", "onClick"])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.state.culprit_name) + ":", 1)
          ])
        ]))
  ]))
}